import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-display-mode-control',
  templateUrl: './display-mode-control.component.html',
  styleUrls: ['./display-mode-control.component.scss']
})
export class DisplayModeControlComponent {
  @Output() displayModeChange = new EventEmitter<'table' | 'list'>();
  
  currentMode: 'table' | 'list' = 'table';

  @Input() initialValue: 'table' | 'list' = 'table';

  ngOnInit() {
    this.currentMode = this.initialValue;
  }

  setMode(mode: 'table' | 'list') {
    this.currentMode = mode;
    this.displayModeChange.emit(mode);
  }
} 